export default (items: any) => {
  const original = [...items] // Copy to avoid endless mutation
  const last = original?.pop()
  return [last, ...original]
}
